import { ActionTypes } from "../constants/action-types";

const initialState = {
    firstPrize: "",
    secondPrize: "",
    otherPrizes: [""],
  totalprizes: 0,
};

export const FetchPrizes = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_PRIZES_SUCCESS:
      return {
        ...state,
        firstPrize: action.payload.firstPrize,
        secondPrize: action.payload.secondPrize,
        otherPrizes: action.payload.otherPrizes,
        totalprizes: action.totalprizes,
      };

    default:
      return state;
  }
};

export default FetchPrizes;
